<template>
    <div class="container-fluid" v-if="!this.$store.state.preloader">
        <div class="text-center">
            <h1>{{ $t("general.login.title") }}</h1>
        </div>
        <div class="row">
            <div class="login-content mt-5">
                <div class="row content">
                    <div class="col-sm-12 mt-3">
                        <div class="form-group">
                            <label>{{ $t("auth.login.email") }}</label>
                            <input type="text" maxlength="50" class="form-control" id="email" name="email" @keyup.enter="loginUser" v-model="fields.email">
                        </div>
                    </div>
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label >{{ $t("auth.login.password") }}</label>
                            <input type="password" class="form-control" @keyup.enter="loginUser" minlength="6" maxlength="50" v-model="fields.password"/>
                        </div>
                    </div>
                    <div class="footer">
                        <button type="submit" @click="loginUser" :disabled="$store.state.ajax_in_progress" class="float-left btn btn-success"><i class="fa fa-sign-in" aria-hidden="true"></i> {{$t('auth.login.title')}}</button>

                        <button class="float-right btn btn-secondary">
                            <i class="fa fa-key" aria-hidden="true"></i> <router-link tag="a" to="/forgotpassword" class="text-white">{{ $t("auth.login.forgot") }}</router-link>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import VeeValidate from 'vee-validate';
    import {vee_config} from '@/constants';

    Vue.use(VeeValidate, vee_config);

    export default {
        components: {},
        name: 'login',

        data() {
            return {
                counter: 0,
                fields: {},
            }
        },
        computed: {
            user() {
                return this.$store.state.user;
            }
        },
        watch: {
            user: {
                immediate: true,

                handler(newVal, oldVal) {
                }
            }
        },
        mounted: function () {
            const jwt = sessionStorage.getItem('jwt');
            if (this.$store.state.user.user && jwt) {
                this.$router.push('/');
            }
        },
        updated: function(){
            const {user} = this.$store.state.user;
            if (user) {
                this.$router.push({path: '/'});
            }
        },
        methods: {
            loginUser ({commit, state}, payload = {}){
                this.$store.state.preloader = true;
                this.$store.dispatch('loginUser', this.fields);
            }
        }
    }
</script>

<style scoped>
    h1 {
        margin: auto;
        text-align: center;
    }
    .container-fluid {
        margin-top: 10%;
    }
    .btn.btn-success {
        font-size: 20px;
        border-radius: 5px;
    }
    .mt-5, .my-5 {
        margin-top: 1rem !important;
    }
    .login-content {
        padding: 5px 20px;
        box-shadow: 0 0 20px #ccc;
        background-size: 100% 100%;
        border-radius: 7px;
        max-width: 30% !important;
        margin: auto;
        overflow: hidden;
    }
    .footer {
        width: 100%;
        margin: 0px 16px 10px 16px;
    }
    .btn {
        padding: 5px 12px;
        font-size: 14px !important;
    }
    .img_backgrond{
        background-size:cover;
        background-repeat:no-repeat;
        width: 100%;
        padding: 75px 15px;
    }
    label{
        font-size: 14px !important;
    }
    ::-webkit-input-placeholder {
        font-size:14px;
    }

    @media screen and (min-width: 1200px) {
        .login-content {
            width: 400px;
            max-width: 95% !important;
            margin: auto;
            overflow: hidden;
        }
    }

    @media screen and (max-width: 1200px) {
        .login-content {
            width: 400px;
            max-width: 95% !important;
            margin: 0 auto;
            overflow: hidden;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/pages/authentication/login.vue